import Modal from "react-modal";
import React from "react";
import rightAnswer from "../../images/rightAnswer.png";
import "../DoneModal/DoneModal.css";

export const DoneModal = ({
  show,
  onClose,
  onContinue,
  correctAnswer,
  referenceAnswer,
}) => {
  // const [showReference, setShowReference] = useState(false);

  // const handleToggle = () => {
  //   setShowReference(!showReference);
  // };

  return (
    <>
      <Modal className="DoneModalBox" isOpen={show} onRequestClose={onClose}>
        <div className="">
          <div className="DoneContent">
            <div className=" modalContainer">
              <div className="d-flex justify-content-center align-items-center gap-2 mb-1">
                <img className="rightImage" src={rightAnswer} alt="" />
                <h2 className="titleExcellent mt-2">
                  Excellent work, doctor!{" "}
                </h2>
              </div>
              <div>
                <p className="paragrap ">
                  <span className="text-success">
                    The correct answer is:{" "}
                    <span className="text-black">{correctAnswer}</span>
                  </span>
                </p>

                {/* <div className="">
                  <button
                    className="text-white bg-purpleColor rounded px-2 py-1 mb-2"
                    onClick={handleToggle}
                  >
                    {showReference
                      ? "Hide Information"
                      : "Click for more information"}
                  </button>
                </div> */}

                <p
                  className="paragraphRef"
                  dangerouslySetInnerHTML={{ __html: referenceAnswer }}
                ></p>

                {/* <p className='paragraph'>You’ve added 15 sec</p> */}
                <span className="plus">+15</span>
              </div>

              <button onClick={onContinue} className=" ContinueButton">
                Continue
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};
